<template>
	<div v-if="shows == '1'">
		<div class="headers">
			<div class="nav">
				<div>
					<img class="img" :src="form.headImgUrl" />
					<div class="main">
						<div class="span1" v-text="form.name"></div>
						<div class="desc" v-text="form.introduce" v-bind:class="[isCollapse ? noAllDesc : allDesc, desc]"></div>
						<div v-if="form.introduce.length > 45">
							<div v-if="isCollapse" class="introduce" @click="collapse(1)">展开介绍</div>
							<div v-if="!isCollapse" class="introduce" @click="collapse(2)">收回介绍</div>
						</div>
						
					</div>
				</div>
			</div>
			<div style="font-size: 0.3rem;margin-top: 0.4rem;color: #fff;text-align: center;margin-bottom: 1.8rem;">
				<img style="width: 0.28rem;height: 0.18rem;" src="../../../assets/img/leftImg.png" />
				<span style="margin: 0 0.2rem;">讲师课件</span>
				<img style="width: 0.28rem;height: 0.18rem;" src="../../../assets/img/rightImg.png" />
			</div>
		</div>
		<div class="aaa">
			<div class="footer" v-for="item in form.appCoursePublicVOList" @click="clickEvents(item.id,3)">
				<img :src="item.logo" />
				<div class="main1">
					<div class="div1" v-text="item.name"></div>
					<div class="div2"><span v-text="item.industryTypeNames"></span><a v-text="item.onlineTime"></a></div>
					<div class="div3"  v-if="item.introduction == ''">暂无简介</div>
					<div class="div3" v-text="item.introduction" v-else></div>
				</div>
			</div>
		</div>
		<div class="baseline">— 更多内容在路上 —</div>
		<!-- <p style="font-size: 0.34rem;text-align: center;margin-top: 0.4rem;color: #000;">更多精彩内容请下载 [交道] APP</p>
		<p class="btn" @click="details()">去看看</p>
		<img style="width: 2.3rem;height: 2.3rem;display: block;margin: 0 auto;margin-bottom: 0.42rem;" src="../../../assets/img/kt.png" /> -->
	</div>
	
	<div v-else id="sc">
		<img src="../../../assets/img/sc.png" />
		<p>抱歉，该内容已不存在</p>
	</div>
	
</template>
<script>
	import {
		Loading,
		Tab,
		Tabs,
		Card
	} from 'vant'
	import request from '@/utils/request'
	export default {
		components: {},
		data() {
			return {
				activeName: 'detail',
				isCollapse: true,
				desc: 'desc',
				noAllDesc: 'noAllDesc',
				allDesc: 'allDesc',
				relationId: '',//624335078977175552
				form: {
					appCoursePublicVOList: [],
					headImgUrl: '',
					introduce: '',
					name: '',
				},
				channeFlag:'2',
				shows:'1'
			}
		},
		created() {
			this.relationId = this.$route.query.id; //获取客户端访问时传的参数ID
			this.initData();
		},
		methods: {
			collapse(status) {
				if (status == 1) {
					this.isCollapse = false;
				} else {
					this.isCollapse = true;
				}
			},
			clickEvents(a,b){
				this.$router.push({
					name: 'PublicCourse',
					query: {
						courseId:a,
						category:b,
						channeFlag:this.channeFlag,
					}
				})
			},
			
			
			initData() {
				let _this = this;
				//let url = Global.env + Global.apiCore.subsystemEnterprises+"/"+this.relationId;
				let url = Global.env + Global.apiCore.lecturerAlbumList + "/" + this.relationId;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							_this.form = response.data;
							return resolve()
						}if (response.resultCode === "20010010") {
										_this.shows = '2'
						} else {
							return reject(response.resultDesc);
						}
					}).catch(error => {
						return reject(error);
					})
				})
			},
			// details() {
			// 	window.location.href = "jt11trafficnews://";
			// 	// window.location.href = "jt11trafficnews://";
			// 	setTimeout(function(){
			// 		location.href = "https://upgrade.jt11.com.cn/html/index.html"
			// 	},3000)
			// }
		}
	}
</script>

<style>
	.headers {
		width: 100%;
		min-height: 5.1rem;
		/* background: url(../../../assets/img/headerimg.png)no-repeat; */
		background: url(~@/assets/img/headerimg.png) no-repeat;
		/* background: url("http://img5.imgtn.bdimg.com/it/u=1638695478,3359394321&fm=26&gp=0.jpg")no-repeat; */
		background-size: 100% 100%;
		overflow: hidden;
	}

	.nav {
		min-height: 2.8rem;
		margin: 0.34rem 0.3rem;
		overflow: hidden;
	}

	.nav img {
		width: 1.52rem;
		height: 2.08rem;
		margin-top: 0.34rem;
		float: left;
		margin-right: 0.32rem;
	}

	.nav .main {
		float: left;
	}

	.nav .main .span1 {
		width: 4.64rem;
		color: #fff;
		font-size: 0.38rem;
		margin-top: 0.4rem;
	}

	.desc {
		width: 4.64rem;
		font-size: .28rem;
		line-height: 0.48rem;
		color: #CECECE;
		padding-right: .16rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.noAllDesc {
		-webkit-line-clamp: 3;
	}

	.allDesc {
		-webkit-line-clamp: initial;
	}

	.introduce {
		color: red;
		font-size: .22rem;
		float: right;
		margin: .12rem;
	}

	.footer {
		height: 2.08rem;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
		border-radius: 8px;
		margin: 0.3rem 0.3rem;
		cursor: pointer;
	}

	.aaa .footer:nth-child(1) {
		height: 2.08rem;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 21px 0px rgba(98, 98, 98, 0.1);
		border-radius: 8px;
		margin: 0 0.3rem;
		margin-top: -1.3rem;
	}

	.btn {
		width: 4.5rem;
		height: 0.88rem;
		background: url(../../../assets/img/bjt.png) round;
		margin: 0 auto;
		font-size: 0.32rem;
		color: #fff;
		text-align: center;
		line-height: 0.88rem;
		margin-bottom: 0.3rem;
		cursor: pointer;
	}

	.footer img {
		width: 1.68rem;
		height: 1.68rem;
		display: block;
		float: left;
		margin: 0.2rem;
	}

	.footer .main1 {
		width: 4.5rem;
		float: left;
	}

	.footer .main1 .div1 {
		font-size: 0.3rem;
		color: #333;
		margin-top: 0.2rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.footer .main1 .div2 {
		margin-top: 0.1rem;
		margin-bottom: 0.08rem;
		overflow: hidden;
	}

	.footer .main1 .div2 span {
		width: 2.4rem;
		color: #666666;
		font-size: 0.26rem;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		float: left;
	}

	.footer .main1 .div2 a {
		color: #666666;
		font-size: 0.26rem;
		float: right;
	}

	.footer .main1 .div3 {
		font-size: 0.26rem;
		color: #999999;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
	#sc{
		text-align: center;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%);
	}
	#sc img{
		display: block;
		width: 1.55rem;
		height: 1.35rem;
		margin: 0 auto;
	}
	#sc p{
		color: #999999;
		font-size: 0.32rem;
		margin-top: 0.28rem;
	}
	.baseline {
		width: 100%;
		height: 0.8rem;
		line-height: 0.8rem;
		text-align: center;
		font-size: 0.26rem;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
	}
	
</style>
